import { apiClient } from '@/api/client';
import { Category } from '@/api/models';
import { useEntityMutations } from '@/hooks/useEntityMutations';
import { queryKeys } from '@/lib/queryKeys';

export interface CategoryFormData {
  name: string;
  enabled: boolean;
}

export const useCategoryMutations = () => {
  return useEntityMutations<CategoryFormData, Category>({
    entityName: 'Category',
    basePath: '/categories',
    queryKeys: [queryKeys.ADMIN_CATEGORIES],
    getId: category => category.id!,
    getDeleteConfirmMessage: category =>
      `Are you sure you want to delete "${category.name}"?`,
    createFn: async data => {
      const response = await apiClient.POST('/admin/categories', {
        body: { name: data.name },
      });
      if (response.error) throw new Error('Failed to create category');
      return response.data;
    },
    updateFn: async data => {
      const response = await apiClient.PUT('/admin/categories/{id}', {
        params: { path: { id: data.id } },
        body: { name: data.name, enabled: data.enabled },
      });
      if (response.error) throw new Error('Failed to update category');
      return response.data;
    },
    deleteFn: async id => {
      const response = await apiClient.DELETE('/admin/categories/{id}', {
        params: { path: { id } },
      });
      if (response.error) throw new Error('Failed to delete category');
    },
  });
};
